import Icon from '@/components/ui/AppIcon';

interface InfoBoxProps {
  title: string;
  description: string;
  icon?: string;
}

const InfoBox = ({ title, description, icon = 'ShieldCheckIcon' }: InfoBoxProps) => {
  return (
    <div className="bg-success/5 border-2 border-success/20 rounded-lg p-6">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <Icon 
            name={icon as any}
            size={28}
            variant="solid"
            className="text-success"
          />
        </div>
        <div>
          <h3 className="font-heading text-lg font-semibold text-foreground mb-2">
            {title}
          </h3>
          <p className="font-body text-sm text-muted-foreground leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InfoBox;